export default "__VITE_ASSET__DFZvZZQR__"